import createBuyerIntentView from './createBuyerIntentView'

const BuyerIntentProfileView = createBuyerIntentView({
  displayName: 'BuyerIntentProfileView',
  tag: 'products.show',
})

export default BuyerIntentProfileView
